export default __webpack_public_path__ + "static/media/ldb-project.19afe9b3.jpeg";